// Per-line / per-order receipt state from the BE: pending → partial → received.
// StatusPill's shared map has no "received" and reads "pending" as an
// approval state, so receipt pills pass an explicit tone + label.
export const RECEIPT_STATUS = {
  pending: { tone: "neutral", label: "Not received" },
  partial: { tone: "warning", label: "Partial" },
  received: { tone: "success", label: "Received" },
}

export const receiptStatusOf = (status) => RECEIPT_STATUS[status] || RECEIPT_STATUS.pending

export const QUALITY_LABEL = { missing: "Missing", excess: "Excess" }
